<div class="flex items-center">
    <div
        class="flex shrink-0 flex-row items-center -space-x-1 sm:-space-x-2"
    >
        <img
        [src]="ASSET_CONSTANTS.I_globe"
        alt="Language"
        class="h-3 w-3 sm:h-4 sm:w-4"
        />
        <nz-select
        [ngModel]="currentLang"
        (ngModelChange)="onLanguageChange($event)"
        class="large font-black"
        [nzBorderless]="true"
        [nzSuffixIcon]="suffixIcon"
        >
        <nz-option nzValue="en" nzLabel="EN"></nz-option>
        <nz-option nzValue="fr" nzLabel="FR"></nz-option>
        <nz-option nzValue="rw" nzLabel="RW"></nz-option>
        <ng-template #suffixIcon>
            <img
            [src]="ASSET_CONSTANTS.I_arrow_down"
            alt="Select"
            class="h-5 w-5 grayscale"
            />
        </ng-template>
        </nz-select>
    </div>
</div>